import React from 'react';
import uniqid from 'uniqid';

import { jsonOrString } from 'SharedHelpers/jsonOrString';
import { isOneColumnLayout } from 'Helpers';
import { getComponentForBlockType } from './getComponentForBlockType';

const withWrapper = (
  {
    type,
  },
) => (Component) => {
  if (!Component) {
    return null;
  }

  let extraClassName;
  if (type.indexOf('SIDE') !== -1) {
    extraClassName = 'aside';
  } else if (type.indexOf('INLINE') !== -1) {
    extraClassName = 'full';
  } else {
    extraClassName = 'main';
  }

  return (
    <div className={`polaris__simple-grid--${extraClassName}`} key={uniqid()}>
      {Component}
    </div>
  );
};

const wrapWithBackground = (components, layoutType) => (
  <div className={`polaris__core-content${isOneColumnLayout({ layoutType }) ? ' -full-width' : ' polaris__simple-grid'}`}>
    {components}
  </div>
);

export const getComponentBlocks = (props, embedTypes) => {
  let options = { props };
  let componentsWithoutDesktopAdsArray = [];
  let bodyArray = [];
  const finalArray = [];
  let wrappedAdsArray = [];
  let sideAd = null;
  const {
    bodyInjected: bodyBlocks,
    blocks,
    mappedContentType,
    bottomComponents = [],
    topComponents,
    layoutType,
    usedCarDeals,
    isMobile,
    hideSidebar,
  } = props;

  if (typeof bodyBlocks === 'undefined' || !Array.isArray(bodyBlocks)) {
    return blocks;
  }

  bodyArray.push(topComponents);

  let numAtAGlanceBlocks = 1;
  const incrementNumAtAGlanceBlocks = () => {
    numAtAGlanceBlocks += 1;
  };

  // Counter for inline ad blocks
  let inlineAdIndex = 0;

  bodyBlocks.forEach((block, index) => {
    const isReactEl = React.isValidElement(block);
    const type = !isReactEl && (block.type || block.__typename);
    const data = !isReactEl && (block.data && jsonOrString(block.data));
    const isDesktopAd = !isMobile && type
    && (type.indexOf('DESKTOP_SIDE_ADVERT') !== -1 || type.indexOf('DESKTOP_INLINE_ADVERT') !== -1);
    const isMobileAd = isMobile && type && (type.indexOf('MOBILE_INLINE_ADVERT') !== -1);

    // Increment inline ad index if block is an inline ad
    if (block.placeholder === 'INLINE_AD_BLOCK') {
      inlineAdIndex += 1;
    }

    options = {
      ...options,
      mappedContentType,
      type,
      block,
      data,
      embedTypes,
      firstBlock: (bodyArray.length === 0),
      index,
      template: props.template || 'article',
      layoutType,
      numAtAGlanceBlocks,
      incrementNumAtAGlanceBlocks,
      inlineAdIndex,
      usedCarDeals,
      isMobile,
    };

    const component = isReactEl ? block : getComponentForBlockType(options);

    if (isDesktopAd || isMobileAd) {
      const wrappedAd = withWrapper(options)(component);
      if (!wrappedAd) return;

      // if inline ad
      if (componentsWithoutDesktopAdsArray.length > 0 && (type.indexOf('INLINE') !== -1)) {
        // Wrap non-inline ad components in a div with class 'polaris__simple-grid--main'
        const wrappedComponentsWithoutDesktopAd = withWrapper({ ...options, type: 'main' })(componentsWithoutDesktopAdsArray);
        // Push this wrapped component to the bodyArray
        bodyArray.push(wrappedComponentsWithoutDesktopAd);

        // Add side ad if there is one
        if (sideAd && !hideSidebar) {
          bodyArray.push(sideAd);
          sideAd = null;
        }

        // Add the next layer of wrapping to  bodyArray all other components
        // Add these classes to the rest of the bodyArray components
        const wrappedBodyArray = wrapWithBackground(bodyArray, layoutType);

        // const wrappedBodyArray = wrapWithBackground(bodyArray);
        // Push the wrapped bodyArray to the finalArray
        finalArray.push(wrappedBodyArray);

        // Push the wrapped ad to the wrapped Ads Array
        wrappedAdsArray.push(wrappedAd);
        // Push all wrapped ads to the finalArray
        wrappedAdsArray.forEach(el => finalArray.push(el));

        // Reset the arrays
        wrappedAdsArray = [];
        componentsWithoutDesktopAdsArray = [];
        bodyArray = [];

        return;
      }

      // if side ad
      if (!hideSidebar) {
        sideAd = wrappedAd;
      }

      return;
    }

    componentsWithoutDesktopAdsArray.push(component);
  });

  // adds components to the bottom of body - gives more space to side ad
  if (Array.isArray(bottomComponents) && bottomComponents.length > 0) {
    bottomComponents.forEach(el => componentsWithoutDesktopAdsArray.push(el));
  }

  if (componentsWithoutDesktopAdsArray.length > 0) {
    const wrappedComponentsWithoutDesktopAd = withWrapper({ ...options, type: 'main' })(componentsWithoutDesktopAdsArray);
    bodyArray.push(wrappedComponentsWithoutDesktopAd);
    componentsWithoutDesktopAdsArray = [];
  }

  if (sideAd) {
    bodyArray.push(sideAd);
    sideAd = null;
  }

  // Add the next layer of wrapping to all bodyArray components currently in the bodyArray
  const wrappedBodyArray = wrapWithBackground(bodyArray, layoutType);
  // Push the wrapped bodyArray to the finalArray
  finalArray.push(wrappedBodyArray);
  return finalArray;
};
